import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import firebase from 'firebase';
import { ICheckUserAnswer } from 'src/app/interfaces/IAuth';
import { AlertService } from 'src/app/services/alert/alert.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CaptchaService } from 'src/app/services/captcha/captcha.service';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { environment } from 'src/environments/environment';
import { TYPES_REGISTER } from '../register/register.page';
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-recover-account',
  templateUrl: './recover-account.page.html',
  styleUrls: ['./recover-account.page.scss'],
})
export class RecoverAccountPage implements OnInit, OnDestroy {

  recoverAccountForm: FormGroup;
  captcha: string;
  LOADER_ID = "recover-account";
  error;
  register_type
  phoneIndicators
  checkIfRegistered$: Subscription
  getRegisterConfigData$: Subscription

  constructor(public formBuilder: FormBuilder,
    private authService: AuthService,
    private loaderService: LoaderService,
    private router: Router,
    private storageService: StorageService,
    private alertService: AlertService,
    private captchaService: CaptchaService,
    private remoteConfig: RemoteConfigService,
    public languageService: LanguagesService
  ) {
    this.initConstructor();
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if(this.checkIfRegistered$)this.checkIfRegistered$.unsubscribe();
    if(this.getRegisterConfigData$)this.getRegisterConfigData$.unsubscribe();
  };

  initConstructor() {
    this.recoverAccountForm = this.formBuilder.group({
      document: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(3)
        ]),
      ]
    });
  }

  get f() {
    return this.recoverAccountForm.controls;
  }

  ionViewDidEnter() {
    this.getUserType();
    this.getIndicators();
  }
 getUserType() {
    const body = {
      app_id: environment.gluky.app_id,
    }
    this.getRegisterConfigData$ = this.authService.getRegisterConfigData(body).subscribe( (res: any) => { 
       this.register_type = res[0]?.register_type ?? TYPES_REGISTER.iddoc;
      //  this.register_type = TYPES_REGISTER.username;
       if(res){
        const validatorsPhone = {
          phone: [Validators.required,Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')],
          email:[Validators.required,Validators.minLength(8), Validators.pattern("^[a-zA-Z0-9#$%&'*/=?^_+-`{|}~]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"), Validators.email],
          username: [Validators.required,Validators.minLength(4)]
        }
        
        if(this.register_type != TYPES_REGISTER.iddoc) {
          this.recoverAccountForm.controls['document'].setValidators(validatorsPhone[this.register_type]);
          this.recoverAccountForm.controls['document'].updateValueAndValidity();
          if(this.register_type == TYPES_REGISTER.phone) {
            this.recoverAccountForm.addControl('indicator', this.formBuilder.control('', Validators.required));
            this.recoverAccountForm.updateValueAndValidity();
          }
        }
         
      }
    })
    
  }
async getIndicators(){
    var indicatorStorage = await this.storageService.get('phoneIndicators');
    if(indicatorStorage && indicatorStorage.length > 0 ){
      this.phoneIndicators = indicatorStorage;
    } else {
      this.remoteConfig.getInfoApp().subscribe((data: any) => {
        if(data['phone-indicators']){
          this.phoneIndicators = data['phone-indicators'];
          this.storageService.set('phoneIndicators', this.phoneIndicators);
        }
      });
    }
    
  }
  async recoverAccount() {
    if(!this.recoverAccountForm.valid){
      this.alertService.presentAlert('Escribe tu número de documento para continuar');
      return;
    }
    this.loaderService.presentLoading(this.LOADER_ID)
    const containerCaptcha = document.getElementById('recaptcha-recover-account');
    const id = Math.round(Math.random());
    containerCaptcha.innerHTML = `<div id='recaptcha-recover-account${id}'></div>`
    window['grecaptcha'].render(`recaptcha-recover-account${id}`, {
      'sitekey': this.captchaService.siteKey,
      'size': 'invisible'
    });
    window['grecaptcha'].execute().then(token => {
      this.checkDocument(token);
      document.getElementById(`recaptcha-recover-account${id}`).remove();
    });
    this.loaderService.cancelLoader(this.LOADER_ID);
  }

  checkDocument(token) {
    const body = {
      app_id: environment.gluky.app_id,
      iddoc: this.f.document.value.trim(),
      captcha: token
    }
    if(this.register_type != 'iddoc') {
      body[this.register_type] = this.register_type == 'phone' ? this.f.indicator.value.indicator + this.f.document.value : this.f.document.value 
      delete body['iddoc'];
     }
     this.checkIfRegistered$ = this.authService.checkIfRegistered(body).subscribe((res: ICheckUserAnswer) => {
      if (res.registered) {
        this.storageService.set('emailRecover', res.email);
        this.storageService.set('phoneRecover', res.phone);
        if (res.recovery_method == 'email' && res.email) {
          this.sendRecoverEmail(res.email);
          this.router.navigateByUrl('login');
        } else if (res.recovery_method == 'phone') {
          this.router.navigateByUrl('otp');
        } else {
          this.router.navigateByUrl('recover-method');
        }
        this.loaderService.cancelLoader(this.LOADER_ID);
      } else {
        this.loaderService.cancelLoader(this.LOADER_ID);
        this.error = "Usuario no registrado";
      }
      this.recoverAccountForm.reset();
    },
      error => {
        this.error = error.error.message;
        this.loaderService.cancelLoader(this.LOADER_ID)
      });
  }

  sendRecoverEmail(email) {
    firebase.auth().sendPasswordResetEmail(email)
      .then((res) => {
        this.router.navigateByUrl('confirm-auth');
      })
      .catch((error) => {
        this.error = error.message;
        console.error(error);
        switch (error.code) {
          case 'auth/invalid-email':

            break;
          case 'auth/missing-android-pkg-name':

            break;
          case 'auth/missing-continue-uri':

            break;
          case 'auth/missing-ios-bundle-id':

            break;
          case 'auth/invalid-continue-uri':

            break;
          case 'auth/unauthorized-continue-uri':

            break;
          case 'auth/user-not-found':

            break;
          default:
            break;
        }
      });
  }
  get getTextsPageRegister() {
    return this.languageService.textsIU.page_register;
  }
}
